// extracted by mini-css-extract-plugin
export default {"question":"DatingPreferenceSingleChoice_question__77w9+"};